export default "__VITE_ASSET__Dc10yFr0__"